export default "__VITE_ASSET__Bw2T41$3__"